export const SENSORS_LOADING_MESSAGE = "Estamos consultando la información de tus sensores";
export const ERROR_401_MESSAGE = "Ups, parece que te has estado inactivo por mucho tiempo. Ingresa nuevamente ";
export const GRAPHS_LOADING_MESSAGE = "Estamos cargando la información de tus sensores";

export const NOT_ALLOWED_ORIENTATION = {
    PORTRAIT_PRIMARY: "portrait-primary",
    PORTRAIT_SECONDARY: "portrait-secondary",
};

export const OPERATORS = [
    {
        label: "Telit",
        value: "Telit"
    },
    {
        label: "Claro",
        value: "Claro"
    },
    {
        label: "Movistar",
        value: "Movistar"
    },
    {
        label: "ETB",
        value: "ETB"
    },
    {
        label: "Tigo",
        value: "Tigo"
    },
    {
        label: "Avantel",
        value: "Avantel"
    },
    {
        label: "Virgin",
        value: "Virgin"
    }

];

export const BOOLEAN_OPTIONS = [
    { label: 'Sí', value: "true" },
    { label: 'No', value: "false" },
];


export const SINGLE_VALUE_DAILY_VARS_CONTS = ['EVT', 'GDD', 'RHS', 'CHL'];

export const SINGLE_VALUE_DAILY_VARS_CONTS_WITHOUT_EVENTS = ['EVT', 'GDD', 'CHL'];

export const VARIABLES_WITH_ADJUSTED_CE = ['CE', 'CE2', 'CE3'];

export const VARIABLES_WITH_ADJUSTED_PH = ['PH', 'PH2', 'PH3'];

// Order in which variables should appear in the "Datos actuales" card, for the
// productor's most relevant variables first. Anything not listed here is appended after.
export const CURRENT_READINGS_PRIORITY_VARS = ['TA', 'HA', 'Rd', 'HS', 'RHS', 'PH', 'PH2', 'PH3', 'CE', 'CE2', 'CE3'];
// Nombres legibles de los roles; los que no estén aquí se muestran tal cual
export const ROLE_LABELS = {
    ROLE_USER: 'Usuario',
    ROLE_USER_RENT: 'Usuario (alquiler)',
    ROLE_USER_SOLAR_PAN: 'Usuario (panel solar)',
    ROLE_ADMIN: 'Administrador',
    ROLE_SELLER: 'Vendedor',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || '-';
